<template>
  <div class="fl-empty-layout">
    <slot name="router"></slot>
  </div>
</template>

<script>
export default {
  name: 'FlEmptyLayout'
}
</script>

<style lang="scss" scoped>
.fl-empty-layout {
  @include grid;
  align-content: start;
  grid-template-rows: 1fr;
}
</style>
